// shared/MarketplaceFooter.jsx

import React from "react";
import { Link } from "react-router-dom";
import { brand, WA_HREF } from "./brand";

const PLATFORM_LINKS = [
  { label: "Beneficios", to: "/?scroll=beneficios" },
  { label: "Cómo funciona", to: "/?scroll=proceso" },
  { label: "Programa de referidos", to: "/?scroll=referidos" },
  { label: "Tecnología", to: "/?scroll=tecnologia" },
  { label: "Cobertura", to: "/?scroll=cobertura" },
  { label: "Precios", to: "/?scroll=precios" },
];

export function MarketplaceFooter() {
  return (
    <footer className="mt-auto border-t border-slate-100 bg-white">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 py-10 md:grid-cols-4">
        <div className="col-span-2">
          <Link to="/" className="mb-3 flex items-center gap-2">
            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="FAST MAX" className="h-7 w-auto" />
            <span className="text-base font-extrabold italic tracking-wide" style={{ color: brand.primary }}>
              FAST MAX
            </span>
          </Link>
          <p className="max-w-sm text-sm leading-relaxed text-slate-500">
            Plataforma logística para vendedores online en Lima. Entregas el mismo
            día con seguimiento en vivo y cobro contraentrega.
          </p>
        </div>

        <div>
          <h4 className="mb-3 text-xs font-bold uppercase tracking-wide text-slate-700">
            Plataforma
          </h4>
          <ul className="space-y-2 text-sm text-slate-500">
            {PLATFORM_LINKS.map(link => (
              <li key={link.to}>
                <Link to={link.to} className="transition-colors hover:text-slate-800">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-3 text-xs font-bold uppercase tracking-wide text-slate-700">
            Contacto
          </h4>
          <ul className="space-y-2 text-sm text-slate-500">
            <li>contacto@fastmax.pe</li>
            <li>
              <a
                href={WA_HREF}
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-green-600 hover:underline"
              >
                WhatsApp: +51 977 689 676
              </a>
            </li>
            <li>Los Mirtos 145, Lima, Perú</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-100 py-4">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 text-xs text-slate-400 sm:flex-row">
          <p>© {new Date().getFullYear()} FAST MAX. Todos los derechos reservados.</p>
          <div className="flex gap-4">
            <Link to="/terms" className="transition-colors hover:text-slate-600">Términos</Link>
            <Link to="/privacy" className="transition-colors hover:text-slate-600">Privacidad</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
